import React from 'react';

function Turkish({ accent }) {
  return (
    <svg viewBox="0 0 64 64" className="w-full h-full" fill="none">
      <rect width="64" height="64" rx="16" fill={accent} />
      <circle cx="28" cy="32" r="15" fill="#fff" />
      <circle cx="32" cy="32" r="12.5" fill={accent} />
      <path d="M44 24.5l2.6 5.6 6.1.7-4.5 4.2 1.2 6-5.4-3-5.4 3 1.2-6-4.5-4.2 6.1-.7z" fill="#fff" />
    </svg>
  );
}

function Asian({ accent }) {
  return (
    <svg viewBox="0 0 64 64" className="w-full h-full" fill="none">
      <rect width="64" height="64" rx="16" fill="#071A3A" />
      <circle cx="32" cy="32" r="17" stroke={accent} strokeWidth="3" />
      <path d="M32 15a17 17 0 0 1 0 34 8.5 8.5 0 0 1 0-17 8.5 8.5 0 0 0 0-17z" fill={accent} />
      <circle cx="32" cy="23.5" r="2.6" fill="#071A3A" />
      <circle cx="32" cy="40.5" r="2.6" fill={accent} />
      <path d="M12 32h6M46 32h6" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

function Box24({ accent }) {
  return (
    <svg viewBox="0 0 64 64" className="w-full h-full" fill="none">
      <rect width="64" height="64" rx="16" fill="#071A3A" />
      <path d="M14 24l18-9 18 9v18l-18 9-18-9z" stroke={accent} strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M14 24l18 9 18-9M32 33v18" stroke={accent} strokeWidth="2.5" strokeLinejoin="round" opacity=".55" />
      <text x="32" y="30" textAnchor="middle" fontFamily="JetBrains Mono, monospace" fontWeight="700" fontSize="13" fill="#fff">24</text>
    </svg>
  );
}

const MARKS = { 'turkish-team': Turkish, 'asian-tips': Asian, '24-box': Box24 };

export default function TipsterLogo({ tipster, className = 'w-12 h-12' }) {
  const Mark = MARKS[tipster.id] || Box24;
  return (
    <div className={`${className} flex-shrink-0 drop-shadow-sm`} data-testid={`tipster-logo-${tipster.id}`}>
      <Mark accent={tipster.accent} />
    </div>
  );
}
